import React from "react";
// javascript library that creates a parrallax effect
import Rellax from "rellax";
// reactstrap components
import {
  Container,
  Row,
  Col,
  Card,
  CardBody
} from "reactstrap";
// core components

function AfectarPublico() {

  React.useEffect(() => {
    document.body.classList.add("presentation-page");
    document.body.classList.add("sidebar-collapse");
    document.documentElement.classList.remove("nav-open");
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;

    // initialise Rellax for this page
    if (window.innerWidth >= 991) {
      setTimeout(function () {
        new Rellax(".rellax", {
          center: true,
        });
      }, 5000);
      new Rellax(".rellax-header");
      new Rellax(".rellax-text");
    }

    // we need to add a script for the github buttons
    let script = document.createElement("script");
    script.src = "https://buttons.github.io/buttons.js";
    script.id = "github-buttons-script-id";
    document.body.appendChild(script);

    return function cleanup() {
      document.body.classList.remove("tramites-page");
      document.body.classList.remove("sidebar-collapse");

      // we need to remove the script when we change the page
      script.parentNode.removeChild(script);
    };
  });
  return (
    <>
      <div className="wrapper">
        <div id="servicio" style={{ backgroundColor: "#f9f9f9" }}>
          <Container className="fluid">
            <Row className="justify-content-center">
              <Col lg="12">
                <h1 className="text-center title" style={{ color: "#031425" }}>
                  Información sobre decisiones que puede afectar al público <br></br>
                </h1>
              </Col>
            </Row>
            <Row>
              <Col md="12">
                <Card>
                  <CardBody>
                    <Row className="justify-content-center">
                      <Col md="6">
                        <center>
                          <a href={"https://drive.google.com/file/d/1Hviq5PKe2CxQbkurbyrD9vBIBSKpkI8e/view?usp=sharing"} style={{ textDecoration: "none !important" }} target="_black">
                            <img
                              alt="magen con referencia circular 1334"
                              width="80px"
                              src={require("assets/img/notarias/pdf.png")}
                            ></img>
                            <h6>Circular 1334 de 2019</h6>
                          </a>
                        </center>
                        <center>
                          <a href={"https://drive.google.com/file/d/1t5UnRJ-YBpObYUFsleFv2WSASfD6GS2-/view?usp=sharing"} style={{ textDecoration: "none !important" }} target="_black">
                            <img
                              alt="magen con referencia circular 1334"
                              width="80px"
                              src={require("assets/img/notarias/pdf.png")}
                            ></img>
                            <h6>Sabados Turno 2025</h6>
                          </a>
                        </center>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    </>
  );
}

export default AfectarPublico;